import React, { Component } from 'react'
import Auth from '../../Modules/Auth'
import axios from 'axios'
import './IntroDetailPage.scss'
import { withCookies, Cookies } from 'react-cookie'
import { Link } from 'react-router-dom'
import HeaderMenu from '../../Components/Commons/HeaderMenu'
import ReactGA from 'react-ga'
import PDFReader from '../../Components/Commons/PDFReader'
import Select from 'react-select'

const groupStyles = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
}
const groupBadgeStyles = {
    backgroundColor: '#EBECF0',
    borderRadius: '2em',
    color: '#172B4D',
    display: 'inline-block',
    fontSize: 12,
    fontWeight: 'normal',
    lineHeight: '1',
    minWidth: 1,
    padding: '0.16666666666667em 0.5em',
    textAlign: 'center',
}

const imageFormat = ['jpg', 'jpeg', 'png', 'gif']
const forgeViewerFormat = [
    '3dm',
    '3ds',
    'a',
    'asm',
    'asm',
    'asm',
    'brd',
    'catpart',
    'catproduct',
    'cgr',
    'collaboration',
    'dae',
    'dgn',
    'dlv3',
    'dwf',
    'dwfx',
    'dwg',
    'dwt',
    'dxf',
    'emode',
    'exp',
    'f2d',
    'f3d',
    'fbx',
    'g',
    'gbxml',
    'glb',
    'gltf',
    'iam',
    'idw',
    'ifc',
    'ige',
    'iges',
    'igs',
    'ipt',
    'iwm',
    'jt',
    'max',
    'model',
    'mpf',
    'msr',
    'neu',
    'neu',
    'nwc',
    'nwd',
    'obj',
    'par',
    'pmlprj',
    'pmlprjz',
    'prt',
    'prt',
    'psm',
    'psmodel',
    'rvt',
    'sab',
    'sat',
    'sch',
    'session',
    'skp',
    's3m',
    'sldasm',
    'sldprt',
    'ste',
    'step',
    'stl',
    'stla',
    'stlb',
    'stp',
    'stpz',
    'vue',
    'wire',
    'x_b',
    'x_t',
    'xas',
    'xpr',
]
const pdftronFormat = ['pdf', 'csv']

const availFormats = [...imageFormat, ...forgeViewerFormat, ...pdftronFormat]

const formatGroupLabel = (data) => (
    <div style={groupStyles}>
        <span>{data.label}</span>
        <span style={groupBadgeStyles}>{data.options.length}</span>
    </div>
)

const FileViewer = ({ item }) => {
    return (
        <div className="file_item">
            <div className="file_view">
                {item.origin === 'FORGE' ? (
                    <iframe
                        src={`/forge/?fid=${item.urn}`}
                        frameBorder="0"
                        onmousewheel="false"
                        allowFullScreen
                        mozallowfullscreen
                        webkitallowfullscreen></iframe>
                ) : (
                    <PDFReader url={item.url} />
                )}
            </div>
        </div>
    )
}

class IntroDetailPage extends Component {
    constructor(props) {
        super(props)

        this.state = {
            drawings: [], // select component를 위한 데이터
            raw_drawings: [], // backend에서 받은 도면 데이터
            selectedOption: null, // 현재 선택된 도면
        }
    }

    UNSAFE_componentWillMount() {
        this.loadDrawings()
    }

    componentDidMount() {
        window.scrollTo(0, 0)
    }

    loadDrawings = () => {
        axios
            .get(`${BACKEND_HOST}/drawings/files/?project_id=${this.props.cookies.get('project')}`, {
                headers: {
                    Authorization: `bearer ${Auth.getToken()}`,
                },
            })
            .then((res) => {
                console.log(res.data)
                this.setState({ raw_drawings: res.data })
                const drawings = this.state.drawings
                let defaultDrawing = null

                for (let i = 0; i < res.data.length; i += 1) {
                    if (res.data[i].category === null) {
                        // 카테고리가 없는 도면
                        for (let k = 0; k < res.data[i].files.length; k += 1) {
                            const item = res.data[i].files[k]
                            if (availFormats.includes(item.fileExtension)) {
                                const drawing = {
                                    value: item._id,
                                    label: item.displayName,
                                }
                                drawings.push(drawing)
                                if (defaultDrawing === null) {
                                    defaultDrawing = drawing
                                }
                            }
                        }
                    } else {
                        // 카테고리 있는 도면
                        const options = []
                        for (let k = 0; k < res.data[i].files.length; k += 1) {
                            const item = res.data[i].files[k]
                            if (availFormats.includes(item.fileExtension)) {
                                const drawing = {
                                    value: item._id,
                                    label: item.displayName,
                                }
                                options.push(drawing)
                                if (defaultDrawing === null) {
                                    defaultDrawing = drawing
                                }
                            }
                        }
                        drawings.push({
                            label: res.data[i].category,
                            options: options,
                        })
                    }
                }

                // 첫번째 도면을 기본값으로 선택
                this.setState({ drawings }, () => {
                    if (defaultDrawing) {
                        this.setState({ selectedOption: defaultDrawing })
                    }
                })
            })
            .catch((err) => {
                console.log(err)
            })
    }

    renderDrawing = () => {
        if (this.state.selectedOption) {
            const drawings = this.state.raw_drawings
            return drawings.map((group) => {
                return group.files.map((drawing) => {
                    if (drawing._id === this.state.selectedOption.value) {
                        return <FileViewer item={drawing} key={drawing._id} />
                    }
                })
            })
        }
    }

    handleSelect = (selectedOption) => {
        this.setState({ selectedOption })
    }

    render() {
        //if (this.state.drawings.length > 0) {
        return (
            <div>
                <HeaderMenu />
                <div className="section_wrap section_wrap_menu">
                    <div className="intro_detail_wrap common_detail">
                        <div className="select_wrap">
                            <Select
                                name="drawing_files"
                                value={this.state.selectedOption}
                                onChange={this.handleSelect}
                                placeholder="도면 선택"
                                clearable={false}
                                options={this.state.drawings}
                                formatGroupLabel={formatGroupLabel}
                                noOptionsMessage={() => '등록된 도면이 없습니다.'}
                            />
                        </div>

                        <div className="drawing_section">
                            <div className="content_wrap">{this.renderDrawing()}</div>
                        </div>
                    </div>
                </div>
            </div>
        )
        // }
        // return (
        //     <div>
        //         <HeaderMenu />
        //         <div className="section_wrap" />
        //     </div>
        // )
    }
}

export default withCookies(IntroDetailPage)



// WEBPACK FOOTER //
// ./Src/Containers/Intro/IntroDetailPage.js